module.exports = __webpack_public_path__ + "img/video-sence.76c6037d.png";